import { DependenciesMap } from './types';

export const initDependenciesMap = (
  predecessors?: string[],
  successors?: string[]
): DependenciesMap => {
  const map: DependenciesMap = {};
  if (predecessors && predecessors.length > 0)
    map.depends_on = [...predecessors];
  if (successors && successors.length > 0) map.blocks = [...successors];
  return map;
};
